var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLikeToggle = function SvgLikeToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.535 0c2.484 0 4.866.986 6.622 2.743L16 2.59l.076-.073A9.36 9.36 0 0 1 22.142.006L22.465 0h.17a9.365 9.365 0 0 1 6.39 16.211l-12.343 11.52a1 1 0 0 1-1.364 0L2.975 16.211A9.365 9.365 0 0 1 9.365 0zm0 2h-.17a7.365 7.365 0 0 0-5.026 12.749L16 25.63l11.66-10.882a7.36 7.36 0 0 0 2.334-5.093l.006-.29A7.365 7.365 0 0 0 22.635 2h-.17a7.36 7.36 0 0 0-5.208 2.157l-.55.55a1 1 0 0 1-1.414 0l-.55-.55A7.36 7.36 0 0 0 9.535 2"
  })));
};
export default SvgLikeToggle;